//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WX_API from '@/utils/wx_api'
import Audio from './audio'
import ChatTools from '../_base_components/_chat_tools'
const { windowWidth, windowHeight, screenHeight, safeArea } = wx.getSystemInfoSync()
const RATIO = windowWidth / 750
let save_height = windowHeight
if (safeArea && safeArea.height) {
    save_height = windowHeight - (screenHeight - safeArea.bottom)
}

const touch_cancel_height = save_height - 160 * RATIO
const MAX_DURATION = 60
let record_start_time
let RecordManager
let check_duration_task
let record_task
export default {
    components: {
        ChatTools
    },
    props: {
        show_building_report: Boolean,
        show_stickers: Boolean,
        msg: String,
        show_tools: Boolean,
        can_send: Boolean,
        is_peer_blocked: Boolean,
        show_expression: Boolean,
        show_picker: Boolean,
        is_consultant_user: Boolean,
        tim_session_id: [String, Number],
        user_loaded:Boolean,
        target_is_consultant:Boolean,
        show_invite:Boolean,
        invite_disable:Boolean
    },
    data () {
        return {
            focus: false,
            open_audio: false,
            recording: false,
            touching_record: false,
            show_cancel: false,
            audio_temp_path: '',
            audio_duration: 0,
            temp_duration: MAX_DURATION
        }
    },
    watch: {
        can_send (latest) {
            if (!latest) {
                this.focus = false
            }
        }
    },
    computed: {
        hide_add_btn () {
            return this.msg || !this.can_send
        },
        hide_send_btn () {
            return !this.msg || !this.can_send
        },
        show_audio_rundown () {
            return this.temp_duration <= 10
        }
    },
    methods: {
        recordStart () {
            this.$emit('checkBlocked')
            if (this.is_peer_blocked) {
                return
            }
            this.$emit('hideBottom')
            Audio.stop()
            this.touching_record = true
            record_task = setTimeout(async () => {
                try {
                    if (this.touching_record) {
                        await WX_API.authRecord()
                        wx.vibrateShort()
                        this.startRecord()
                    } else {
                        clearTimeout(record_task)
                    }
                } catch (err) {
                    this.resetRecord()
                    console.error(err)
                }
            }, 200)
        },
        recordEnd () {
            if (RecordManager) {
                RecordManager.stop()
            }
            this.resetRecord()
        },
        resetRecord () {
            this.touching_record = false
            this.recording = false
            this.temp_duration = MAX_DURATION
            check_duration_task && clearTimeout(check_duration_task)
            record_task && clearTimeout(record_task)
        },
        startRecord () {
            RecordManager = wx.getRecorderManager()
            RecordManager.onStart(() => {
                wx.vibrateShort()
                this.recording = true
                this.checkAudioDuration()
            })
            RecordManager.onStop(({ tempFilePath, duration }) => {
                if (!this.show_cancel && duration < 1000) {
                    wx.showToast({
                        title: '说话时间太短',
                        icon: 'none'
                    })
                    return
                }
                if (!this.show_cancel) {
                    this.audio_temp_path = tempFilePath
                    this.audio_duration = parseInt(duration)
                    this.uploadAudio()
                }
                this.show_cancel = false
            })
            RecordManager.start({
                duration: MAX_DURATION * 1000,
                format: 'aac'
            })
        },
        async uploadAudio () {
            try {
                wx.showLoading()
                const url = await WX_API.uploadAudio(this.audio_temp_path)
                this.$emit('sendAudio', {
                    url,
                    duration: this.audio_duration
                })
                wx.hideLoading()
            } catch (err) {
                console.error(err)
                wx.hideLoading()
            }
        },
        checkAudioDuration () {
            check_duration_task = setTimeout(() => {
                this.temp_duration -= 1
                if (this.temp_duration <= 0) {
                    this.recordEnd()
                } else {
                    this.checkAudioDuration()
                }
            }, 1000)
        },
        checkRecordCancel (e) {
            const [{ clientY, pageY }] = e.touches
            this.show_cancel = clientY < touch_cancel_height
        },
        toggleAudio () {
            this.$emit('checkBlocked')
            if (this.is_peer_blocked) {
                return
            }
            this.open_audio = !this.open_audio
            this.$emit('hideBottom')
        },
        changeMsg (e) {
            this.$emit('changeMsg', e.target.value)
        },
        onFocus () {
            this.focus = true
        },
        onBlur () {
            this.focus = false
        },
        send (e) {
            this.$emit('sendMsg', e.target.value)
        },
        tagSend () {
            this.$emit('sendMsg', this.msg)
            setTimeout(this.onFocus)
        },
        submitSend (e) {
            const msg = e.target.value
            this.$emit('sendMsg', msg)
        },
        toggleSticker() {
            if (this.show_stickers) {
                this.focus = true
            } else {
                this.$emit('toggleSticker')
            }
        }
    }
}
